var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBermuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 7.6521V13.0485L10.4344 7.6521H15.9996Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34781 15.9999H13.0485L8.34781 9.73901L7.65219 14.6086L8.34781 15.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9857 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59225 3.51185 3.51181 5.59223 2.08694 8.09466V16.6956H6.26087V6.26098V6.26085H16.6956C16.6956 4.94441 16.6956 3.69029 16.6956 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6361 14.6685L10.3153 8.3479H8.34781V8.34803L16.6359 16.6361H16.636C16.6361 16.6362 16.6361 15.2795 16.6361 14.6685Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 8.3479V16C18.0869 19.7275 27.8261 19.7275 27.8261 16V8.3479H18.0869Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 16.0001V16C18.0869 19.7275 22.9565 20.8696 22.9565 20.8696C22.9565 20.8696 27.8261 19.7275 27.8261 16V16.0001H18.0869Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 12.9392L20.6953 13.9131V16.0001L22.9562 17.3914L25.2171 16.0001V13.9131L22.9562 12.9392Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 11.8262H25.2171V13.9131H20.6953V11.8262Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBermuda);
export default __webpack_public_path__ + "static/media/flag_bermuda.f1d0d9be76edddaf3d9386ca12761fd1.svg";
export { ForwardRef as ReactComponent };